(function(){
if(window.__plv3)return;window.__plv3=true;
var X=window.PLX_I18N||{};var LOC=X.locale||document.documentElement.lang||'sv';function T(k,fb){return X[k]!=null?X[k]:fb;}function F(t){var a=[].slice.call(arguments,1);return String(t).replace(/%(\d)/g,function(m,i){return a[+i-1];}).replace('%s',a[0]);}
// Same window as the PDP box (sections/plv3-main-product.liquid): +12 working days (weekends + H skipped), then a 2-day span.
var H=['2026-12-24','2026-12-25','2026-12-31','2027-01-01','2027-01-06','2027-03-26','2027-03-29','2027-05-06','2027-06-25','2027-12-24','2027-12-31'];
function iso(x){return x.getFullYear()+'-'+('0'+(x.getMonth()+1)).slice(-2)+'-'+('0'+x.getDate()).slice(-2);}
function addBiz(d,n){var x=new Date(d.getFullYear(),d.getMonth(),d.getDate());while(n>0){x.setDate(x.getDate()+1);if(x.getDay()!==0&&x.getDay()!==6&&H.indexOf(iso(x))<0)n--;}return x;}
function win(){var a=addBiz(new Date(),12);return{a:a,b:new Date(a.getFullYear(),a.getMonth(),a.getDate()+2)};}
function fmtShort(d){try{return new Intl.DateTimeFormat(LOC,{day:'numeric',month:'long'}).format(d);}catch(e){return d.getDate()+'/'+(d.getMonth()+1);}}
function winStr(){var w=win();return w.a.getMonth()===w.b.getMonth()?w.a.getDate()+'\u2013'+fmtShort(w.b):fmtShort(w.a)+' \u2013 '+fmtShort(w.b);}
function kr(c){return window.plxMoney?window.plxMoney(c):Math.round(c/100)+' kr';}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}

ready(function(){
  // Delivery estimate (same window as the PDP)
  document.querySelectorAll('[data-plv3-delivery]').forEach(function(el){el.textContent=winStr();});

  // Announcement rotator
  document.querySelectorAll('[data-plv3-announcement]').forEach(function(bar){
    var items=Array.prototype.slice.call(bar.children);if(items.length<2)return;var i=0;
    setInterval(function(){items[i].classList.remove('is-on');i=(i+1)%items.length;var el=items[i];el.classList.remove('is-on');void el.offsetWidth;el.classList.add('is-on');},4200);
  });

  // Occasion date picker
  document.querySelectorAll('[data-plv3-occasion]').forEach(function(inp){
    inp.addEventListener('change',function(){
      var scope=inp.closest('.plv3')||document;
      var msg=scope.querySelector('[data-plv3-occasion-msg]');if(!msg)return;
      msg.classList.remove('is-ok','is-warn','is-late');
      if(!inp.value)return;
      var phone=inp.getAttribute('data-phone')||'';
      var od=new Date(inp.value+'T12:00:00');var odd=new Date(od.getFullYear(),od.getMonth(),od.getDate());
      var w=win();var diff=Math.round((odd-w.b)/86400000);
      var cU=phone?F(T('call','Ring %s'),esc(phone)):T('contactUs','Kontakta oss'),cAt=phone?F(T('callUsAt','Ring oss p\u00e5 %s'),esc(phone)):T('contactUs','Kontakta oss');
      if(diff>=1){msg.classList.add('is-ok');msg.innerHTML='<span>\u2713</span><span>'+F(T('occOk','Levereras i god tid f\u00f6re den %1.'),esc(fmtShort(od)))+'</span>';}
      else if(odd>=w.a){msg.classList.add('is-warn');msg.innerHTML='<span>!</span><span>'+F(T('occWarn','Det kan bli tajt \u2014 ber\u00e4knad leverans %1. %2 s\u00e5 hj\u00e4lper vi dig.'),esc(winStr()),cU)+'</span>';}
      else{msg.classList.add('is-late');msg.innerHTML='<span>!</span><span>'+F(T('occLate','Hinner tyv\u00e4rr inte till den %1 \u2014 ber\u00e4knad leverans %2. %3 s\u00e5 hittar vi en l\u00f6sning.'),esc(fmtShort(od)),esc(winStr()),cAt)+'</span>';}
    });
  });

  // Gallery dots
  document.querySelectorAll('[data-plv3-gallery]').forEach(function(gal){
    var track=gal.querySelector('[data-plv3-track]');var dots=gal.querySelectorAll('.plv3-dot');if(!track)return;
    track.addEventListener('scroll',function(){
      var i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
      dots.forEach(function(d,j){d.classList.toggle('is-on',j===i);});
    },{passive:true});
    dots.forEach(function(d,j){d.addEventListener('click',function(){track.scrollTo({left:j*track.clientWidth,behavior:'smooth'});});});
  });

  // Sticky ATC bar
  var anchor=document.querySelector('[data-plv3-atc-anchor]');var sticky=document.querySelector('[data-plv3-sticky]');
  if(anchor&&sticky&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){es.forEach(function(en){sticky.classList.toggle('is-on',!en.isIntersecting&&window.scrollY>250);});}).observe(anchor);
  }
  // When an app (Customily) replaces the native ATC with its own validated button,
  // the sticky bar must go through that button - never submit the raw form past validation.
  var stickyBtn=sticky?sticky.querySelector('button'):null;
  if(stickyBtn){stickyBtn.addEventListener('click',function(e){
    var form=document.querySelector('form[data-plv3-atc]');if(!form)return;
    var appBtn=Array.prototype.filter.call(form.querySelectorAll('button[type=button]'),function(b){return b.offsetHeight>0&&(window.plxRxText?plxRxText('atc','Lägg i varukorgen'):/Lägg i varukorgen/i).test(b.textContent);})[0];
    if(appBtn){e.preventDefault();appBtn.scrollIntoView({behavior:'smooth',block:'center'});appBtn.click();}
  });}

  // ---- Cart drawer ----
  var drawer=document.querySelector('[data-plv3-drawer]');
  function cfgNum(name,fb){if(!drawer)return fb;var v=parseInt(drawer.getAttribute(name),10);return isNaN(v)?fb:v;}
  function cfg(name){return drawer?(drawer.getAttribute(name)||''):'';}

  function openDrawer(){if(!drawer)return;drawer.classList.add('is-open');document.body.style.overflow='hidden';refresh();}
  function closeDrawer(){if(!drawer)return;drawer.classList.remove('is-open');document.body.style.overflow='';}

  function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json();});}
  function refresh(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render).catch(function(){});}

  window.__plv3Cmp=window.__plv3Cmp||{};
  function ensureCmp(cart){var m=window.__plv3Cmp;var need=cart.items.filter(function(it){return !(it.variant_id in m);});if(!need.length)return null;var hs=[];need.forEach(function(it){if(hs.indexOf(it.handle)<0)hs.push(it.handle);});
    return Promise.all(hs.map(function(h){return fetch('/products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(p){(p.variants||[]).forEach(function(v){m[v.id]=v.compare_at_price||0;});}).catch(function(){});})).then(function(){need.forEach(function(it){if(!(it.variant_id in m))m[it.variant_id]=0;});});}
  function render(cart){
    var pend=ensureCmp(cart);if(pend){pend.then(function(){render(cart);});}
    document.querySelectorAll('[data-plv3-cart-count]').forEach(function(el){el.textContent=cart.item_count;el.hidden=cart.item_count===0;});
    if(!drawer)return;
    var wrapId=cfg('data-wrap-variant');var crossId=cfg('data-cross-variant');
    var t1=cfgNum('data-tier1',299)*100;
    var t2raw=cfgNum('data-tier2',0),t3raw=cfgNum('data-tier3',0);
    var multiTier=t2raw>0&&t3raw>0;
    var t2=multiTier?t2raw*100:Infinity,t3=multiTier?t3raw*100:Infinity;
    var shipCost=cfgNum('data-ship',0)*100;
    var empty=drawer.querySelector('[data-plv3-drawer-empty]');var full=drawer.querySelector('[data-plv3-drawer-full]');var foot=drawer.querySelector('[data-plv3-drawer-foot]');
    var isEmpty=cart.item_count===0;
    if(empty)empty.hidden=!isEmpty;if(full)full.hidden=isEmpty;if(foot)foot.hidden=isEmpty;
    if(isEmpty)return;

    // Line items (gift wrap rendered as toggle, not as a line)
    var box=drawer.querySelector('[data-plv3-items]');var wrapLine=null;var html='';
    cart.items.forEach(function(it,idx){
      var cmp=(window.__plv3Cmp&&window.__plv3Cmp[it.variant_id])||0;if(cmp<=it.final_price)cmp=0;var cmpLine=cmp*it.quantity;
      if(wrapId&&String(it.variant_id)===wrapId){wrapLine=idx+1;return;}
      var props='';
      if(it.properties){Object.keys(it.properties).forEach(function(k){
        var v=it.properties[k];
        if(k.charAt(0)==='_'||v==null||v==='')return;
        if(/^[0-9a-f-]{20,}$/i.test(String(v))||/^https?:\/\//.test(String(v)))return; // Customily internal ids/urls
        props+=(props?' \u00b7 ':'')+esc(k)+': <strong>'+esc(v)+'</strong>';
      });}
      html+='<div class="plv3-item">'
        +'<div class="plv3-item-thumb">'+(it.image?'<img src="'+esc(it.image)+'" alt="">':'')+'</div>'
        +'<div class="plv3-item-main">'
        +'<div class="plv3-item-top"><strong>'+esc(it.product_title)+'</strong>'+(cmpLine>it.final_line_price?'<span class="plv3-item-price"><b class="plv3-item-now">'+kr(it.final_line_price)+'</b><s class="plv3-item-was">'+kr(cmpLine)+'</s></span>':'<strong style="white-space:nowrap">'+kr(it.final_line_price)+'</strong>')+'</div>'
        +(props?'<p class="plv3-item-props">'+props+'</p>':'<p class="plv3-item-props"></p>')
        +(cmpLine>it.final_line_price?'<p class="plv3-item-unit">'+esc(F(T('unitLine','%1/st \u00b7 ord. %2'),kr(it.final_price),kr(cmp)))+'</p><span class="plv3-item-save">'+esc(F(T('youSave','Du sparar %s'),kr(cmpLine-it.final_line_price)))+' (\u2212'+Math.round((cmpLine-it.final_line_price)/cmpLine*100)+' %)</span>':'')
        +'<div class="plv3-item-row">'
        +'<div class="plv3-qty"><button type="button" data-plv3-qty="'+(it.quantity-1)+'" data-line="'+(idx+1)+'" aria-label="'+esc(T('qtyMinus','Minska antal'))+'">\u2212</button><span>'+it.quantity+'</span><button type="button" data-plv3-qty="'+(it.quantity+1)+'" data-line="'+(idx+1)+'" aria-label="'+esc(T('qtyPlus','\u00d6ka antal'))+'">+</button></div>'
        +'<a class="plv3-item-edit" href="'+esc(it.url)+'">'+esc(T('edit','\u00c4ndra'))+'</a>'
        +'</div></div></div>';
    });
    if(box)box.innerHTML=html;

    // Progress tiers
    var sub=cart.total_price;
    var pct;
    if(!multiTier){pct=Math.min(sub/t1*100,100);}
    else if(sub<=t1)pct=sub/t1*34;else if(sub<=t2)pct=34+(sub-t1)/(t2-t1)*33;else if(sub<=t3)pct=67+(sub-t2)/(t3-t2)*33;else pct=100;
    var fill=drawer.querySelector('[data-plv3-bar-fill]');if(fill)fill.style.width=pct.toFixed(1)+'%';
    [[1,t1],[2,t2],[3,t3]].forEach(function(p){
      var on=p[1]!==Infinity&&sub>=p[1];
      var dot=drawer.querySelector('[data-plv3-dot-'+p[0]+']');if(dot)dot.classList.toggle('is-on',on);
      var lab=drawer.querySelector('[data-plv3-label-'+p[0]+']');if(lab)lab.classList.toggle('is-on',on);
    });
    var msgEl=drawer.querySelector('[data-plv3-tier-msg]');
    if(msgEl){
      var next=null;
      if(sub<t1)next={amt:t1,label:cfg('data-tier1-msg')||T('freeShippingLc','fri frakt')};
      else if(multiTier&&sub<t2)next={amt:t2,label:cfg('data-tier2-msg')||T('giftCardLc','gratis presentkort')};
      else if(multiTier&&sub<t3)next={amt:t3,label:cfg('data-tier3-msg')||T('giftWrapLc','gratis presentinslagning')};
      msgEl.textContent=next?F(T('tierNext','Du \u00e4r %1 fr\u00e5n %2'),kr(next.amt-sub),next.label):(multiTier?T('tierAll','Alla presentf\u00f6rm\u00e5ner uppl\u00e5sta \u2713'):T('tierFree','Fri frakt uppl\u00e5st \u2713'));
    }

    // Gift wrap toggle
    var wrapBtn=drawer.querySelector('[data-plv3-wrap-toggle]');
    if(wrapBtn){
      wrapBtn.classList.toggle('is-on',wrapLine!==null);
      wrapBtn.setAttribute('data-wrap-line',wrapLine===null?'':String(wrapLine));
      var priceEl=wrapBtn.querySelector('[data-plv3-wrap-price]');var wp=cfgNum('data-wrap-price',4900);
      if(priceEl){
        var free=sub>=t3;
        priceEl.classList.toggle('is-free',free);
        priceEl.textContent=free?(wrapLine!==null?T('freeBang','Gratis!'):T('freeUnlocked','Gratis \u2014 uppl\u00e5st!')):'+ '+kr(wp);
      }
    }

    // Cross-sell offer visibility
    var offer=drawer.querySelector('[data-plv3-offer]');
    if(offer&&crossId){var inCart=cart.items.some(function(it){return String(it.variant_id)===crossId;});offer.hidden=inCart;}

    // Totals (display; checkout is source of truth)
    var free=sub>=t1;
    var ship=free?0:shipCost;
    var subEl=drawer.querySelector('[data-plv3-sub]');if(subEl)subEl.textContent=kr(sub);
    var shipEl=drawer.querySelector('[data-plv3-ship]');
    if(shipEl){
      shipEl.textContent=free?T('free','Gratis'):(shipCost>0?kr(shipCost):T('calcAtCheckout','Räknas ut i kassan'));
      shipEl.classList.toggle('plv3-ship-free',free);
    }
    var totEl=drawer.querySelector('[data-plv3-total]');if(totEl)totEl.textContent=kr(sub+ship);
  }

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-plv3-cart-open]');
    if(t){e.preventDefault();openDrawer();return;}
    t=e.target.closest('[data-plv3-drawer-close]');
    if(t){closeDrawer();return;}
    t=e.target.closest('[data-plv3-qty]');
    if(t){post('/cart/change.js',{line:parseInt(t.getAttribute('data-line'),10),quantity:parseInt(t.getAttribute('data-plv3-qty'),10)}).then(render).catch(function(){});return;}
    t=e.target.closest('[data-plv3-wrap-toggle]');
    if(t){
      var line=t.getAttribute('data-wrap-line');
      if(line){post('/cart/change.js',{line:parseInt(line,10),quantity:0}).then(render).catch(function(){});}
      else{var wid=parseInt(cfg('data-wrap-variant'),10);if(wid)post('/cart/add.js',{items:[{id:wid,quantity:1}]}).then(refresh).catch(function(){});}
      return;
    }
    t=e.target.closest('[data-plv3-add]');
    if(t){var vid=parseInt(t.getAttribute('data-variant'),10);if(vid)post('/cart/add.js',{items:[{id:vid,quantity:1}]}).then(function(){openDrawer();}).catch(function(){});return;}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});

  // AJAX add-to-cart on product forms
  document.querySelectorAll('form[data-plv3-atc]').forEach(function(form){
    form.addEventListener('submit',function(e){
      var occ=form.querySelector('[data-plv3-occasion]');
      if(occ&&!occ.value)occ.removeAttribute('name');
      var root=form.closest('[data-plv3-ajax]');
      if(root&&root.getAttribute('data-plv3-ajax')==='false')return; // let Customily / native flow handle it
      e.preventDefault();
      fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(){openDrawer();})
        .catch(function(){form.removeAttribute('data-plv3-atc');form.submit();});
    });
  });

  refresh();
});
})();

/* plv3 nav + search (2026-09-09) */
(function(){
  if(window.__plv3nav)return;window.__plv3nav=true;
  var last=null;
  function q(s){return document.querySelector(s);}
  function open(sel,btnSel,focusSel){var el=q(sel);if(!el)return;last=document.activeElement;el.classList.add('is-open');document.documentElement.classList.add('plv3-lock');var b=q(btnSel);if(b)b.setAttribute('aria-expanded','true');var f=focusSel&&el.querySelector(focusSel);setTimeout(function(){(f||el.querySelector('button,a,input')||el).focus();},80);}
  function close(sel,btnSel){var el=q(sel);if(!el||!el.classList.contains('is-open'))return;el.classList.remove('is-open');if(!q('.plv3-drawer.is-open')&&!q('.plv3-search.is-open'))document.documentElement.classList.remove('plv3-lock');var b=q(btnSel);if(b)b.setAttribute('aria-expanded','false');if(last&&last.focus)last.focus();}
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-plv3-nav-open]')){e.preventDefault();open('[data-plv3-nav]','[data-plv3-nav-open]','.plv3-nav-link');return;}
    if(e.target.closest('[data-plv3-nav-close]')){close('[data-plv3-nav]','[data-plv3-nav-open]');return;}
    if(e.target.closest('[data-plv3-search-open]')){e.preventDefault();open('[data-plv3-search]','[data-plv3-search-open]','.plv3-search-input');return;}
    if(e.target.closest('[data-plv3-search-close]')){close('[data-plv3-search]','[data-plv3-search-open]');return;}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){close('[data-plv3-nav]','[data-plv3-nav-open]');close('[data-plv3-search]','[data-plv3-search-open]');}});
})();

/* plv3 header v2 (2026-09-13): fixed-on-scroll header + desktop mega menu */
(function(){
  if(window.__plv3hdr)return;window.__plv3hdr=true;
  function boot(){
    var h=document.querySelector('[data-plv3-header]');if(!h)return;
    var spacer=document.createElement('div');spacer.className='plv3-header-spacer';h.insertAdjacentElement('afterend',spacer);
    var top=0,fixed=false;
    function measure(){if(fixed){h.classList.remove('is-fixed');spacer.classList.remove('is-on');}top=h.getBoundingClientRect().top+window.scrollY;if(fixed){h.classList.add('is-fixed');spacer.classList.add('is-on');}}
    function onScroll(){var want=window.scrollY>top+2;if(want&&!fixed){spacer.style.height=h.offsetHeight+'px';spacer.classList.add('is-on');h.classList.add('is-fixed');fixed=true;}else if(!want&&fixed){h.classList.remove('is-fixed');spacer.classList.remove('is-on');fixed=false;}}
    measure();onScroll();
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',function(){measure();if(fixed)spacer.style.height=h.offsetHeight+'px';onScroll();});
    var items=[].slice.call(h.querySelectorAll('.plv3-nav-item.has-sub')),timer=null;
    function open(it){items.forEach(function(x){if(x!==it)close(x);});it.classList.add('is-open');it.querySelector('.plv3-nav-a').setAttribute('aria-expanded','true');}
    function close(it){it.classList.remove('is-open');it.querySelector('.plv3-nav-a').setAttribute('aria-expanded','false');}
    items.forEach(function(it){
      var a=it.querySelector('.plv3-nav-a');
      it.addEventListener('mouseenter',function(){clearTimeout(timer);timer=setTimeout(function(){open(it);},80);});
      it.addEventListener('mouseleave',function(){clearTimeout(timer);timer=setTimeout(function(){close(it);},160);});
      a.addEventListener('click',function(e){var touch=window.matchMedia('(hover: none)').matches;if((touch||e.detail===0)&&!it.classList.contains('is-open')){e.preventDefault();open(it);}});
      it.addEventListener('focusin',function(){open(it);});
      it.addEventListener('focusout',function(e){if(!it.contains(e.relatedTarget))close(it);});
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')items.forEach(close);});
    document.addEventListener('click',function(e){if(!e.target.closest('.plv3-nav-item'))items.forEach(close);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
